var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-icon-wrap",style:(_vm.wrapStyle)},[_c('div',{staticClass:"rp-running",style:(_vm.runningStyle)},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-outer"},[_c('div',{staticClass:"rp-body"},[_c('div',{staticClass:"rp-arm rp-behind"}),_c('div',{staticClass:"rp-arm rp-front"}),_c('div',{staticClass:"rp-leg rp-behind"}),_c('div',{staticClass:"rp-leg rp-front"})])])
}]

export { render, staticRenderFns }